export const OAUTH = "OAUTH";
export const WEB3 = "WEB3";
